var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"id":"login-header"}},[_c('div',{staticClass:"logo"},[_c('router-link',{staticClass:"logo__link",attrs:{"to":{ name: 'portalIndex' }}},[_vm._v("ENDREACH")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }